





























import { Component, Watch, Prop } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ReserveRankListTable } from '@/components/organisms/ReserveRankListTable'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { AlertMessage, ErrorMessage, Reserve, reserveApi } from '@/api'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'

import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'

@Component({
  components: {
    ReserveRankListTable,
    ModalFooter
  }
})
export default class ModalReserveRank extends ModalComponentBaseVue {
  @Prop({
    type: Boolean,
    default: false
  })
  editable!: boolean

  dialog: boolean = false

  reserves: Reserve[] = []

  tableBodyHeight: number = 0

  @Watch('dialog')
  initialize(): void {
    if (this.dialog) return this.$nextTick(this.calculateTableHeight)

    this.reserves = []
    this.tableBodyHeight = 0
  }

  @Watch('dialog')
  onShowChanged(val: boolean) {
    val ? this.opened() : this.closed()
  }

  mounted() {
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }

  open(bibliographyId: number): void {
    this.getReserves(bibliographyId)
    this.dialog = true
  }

  close(): void {
    this.dialog = false
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  async getReserves(bibliographyRealId: number) {
    this.$eventBus.emit(PAGE_LOADING_START)
    try {
      this.reserves = await reserveApi.getReserves({
        bibliographyRealId
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-reserve-rank')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  opened(): void {}

  closed(): void {
    this.tableBodyHeight = 0
    this.reserves = []
  }
}
